import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';

import { useAppSelector } from '~/application/hooks';
import { selectIsLoggedIn } from '~/application/store/auth';

export const NonAuthenticatedOutlet = () => {
    const isLoggedIn = useAppSelector(selectIsLoggedIn);
    const navigate = useNavigate();
    const { state } = useLocation();

    useEffect(() => {
        if (isLoggedIn) {
            navigate(state?.from || '/', {
                state: { from: '' },
                replace: true,
            });
        }
    }, [isLoggedIn, state]);

    return !isLoggedIn
        ? <Outlet />
        : null;
};
